import React from 'react'
import { Link } from 'react-router-dom'
import ServicesSlider from './ServicesSlider'

function Services() {
  return (
    <div>
    <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/dronyug/assets/images/subheader.jpg)' }}>
    	<div className="container">
    		<div className="row">
    			<div className="col-12 text-center">
    				<h1 className="text-white page-title">Services</h1>
    			</div>
    		</div>
    	</div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Services Start --> */}
    <ServicesSlider/>
    {/* <!-- Services End -->
    <!-- How It Work Start --> */}
    <section className="section-parallax section-padding how-it-works-parent" style={{ backgroundImage: 'url(/tm/react/dronyug/assets/images/howitworks.jpg)' }}>
        <div className="container">
            <div className="section-header text-center">
                <p className="section_count"></p>
                <h3 className="title text-white">How It Works</h3>
            </div>
        </div>
    </section>
    <div className="how-it-works-sub section-padding pt-0">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-3 col-md-6">
                    <Link to="/service-details" className="service_box style_2">
                        <i className="fas fa-database icon"></i>
                        <h5 className="title">Enter Your Data</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                    </Link>
                </div>
                
                <div className="col-lg-3 col-md-6">
                    <Link to="/service-details" className="service_box style_2">
                        <i className="fas fa-cloud-upload-alt icon"></i>
                        <h5 className="title">upload Data For</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                    </Link>
                </div>
               
                <div className="col-lg-3 col-md-6">
                    <Link to="/service-details" className="service_box style_2">
                        <i className="fas fa-user-circle icon"></i>
                        <h5 className="title">Create Your Page</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                    </Link>
                </div>
                
                <div className="col-lg-3 col-md-6">
                    <Link to="/service-details" className="service_box style_2">
                        <i className="fas fa-brain icon"></i>
                        <h5 className="title">Play For Handover</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                    </Link>
                </div>
                <div className="col-12 text-center">
                    <Link to="/services" className="thm-btn btn-rounded">
                        <span className="button_title">View More</span>
                    </Link>
                </div>
            </div>
        </div>
    </div>
    </div>
  )
}

export default Services